/**
 * This file was generated and should not be edited if you don't want to lose your changes.
 *
 * @see TypeScriptTransformer, command app:types
 */
export enum AutoResultInterval {
    "Seconds" = "seconds",
    "Minutes" = "minutes",
    "Hours" = "hours",
    "Days" = "days",
}
export enum BalanceBlockReason {
    "Manual" = "manual",
    "InvoicedPending" = "invoiced_pending",
    "ApprovedPending" = "approved_pending",
    "PaidPending" = "paid_pending",
}
export enum BalanceRole {
    "Admin" = "admin",
    "Affiliate" = "affiliate",
    "Advertiser" = "advertiser",
}
export enum BalanceSettlement {
    "Uninvoiced" = "uninvoiced",
    "Invoiced" = "invoiced",
    "InvoiceApproved" = "invoice_approved",
    "Paid" = "paid",
    "Hold" = "hold",
}
export enum CascadeAction {
    "PriorityRedirect" = "priority_redirect",
    "Redirect" = "redirect",
    "VisibleOnly" = "visible_only",
    "Hidden" = "hidden",
}
export enum CascadeDistributionType {
    "Exclusive" = "exclusive",
    "Auction" = "auction",
    "NonExclusive" = "non_exclusive",
    "Choice" = "choice",
}
export enum CascadeProcessItemAction {
    "Processing" = "processing",
    "PriorityRedirect" = "priority_redirect",
    "Redirect" = "redirect",
    "Choice" = "choice",
    "Failed" = "failed",
    "PostVerification" = "post_verification",
    "Visible" = "visible",
    "Accepted" = "accepted",
}
export enum CascadeProcessItemStatus {
    "Unused" = "unused",
    "Processing" = "processing",
    "Completed" = "completed",
    "Rejected" = "rejected",
    "Failed" = "failed",
    "Waiting" = "waiting",
    "Declined" = "declined",
    "NextWaiting" = "next_waiting",
}
export enum CascadeProcessStatusResponse {
    "Processing" = "processing",
    "Failed" = "failed",
    "Completed" = "completed",
}
export enum CascadeStatus {
    "Enabled" = "enabled",
    "Disabled" = "disabled",
}
export enum CatalogStatus {
    "Member" = "member",
    "Pending" = "pending",
    "DifferentRole" = "different_role",
    "None" = "none",
}
export enum CheckEmailStatus {
    "New" = "new",
    "ExistingSameRole" = "existing_same_role",
    "ExistingPendingRole" = "existing_pending_role",
    "ExistingDifferentRole" = "existing_different_role",
    "ExistingNoAccess" = "existing_no_access",
}
export enum CommissionType {
    "Tenant" = "tenant",
    "User" = "user",
}
export enum ConnectionCreatorResult {
    "Success" = "success",
    "Failure" = "failure",
    "Waiting" = "waiting",
}
export enum ConnectionCreatorScenarioCategory {
    "Integration" = "integration",
    "StructureValidate" = "structure-validate",
    "StructureModify" = "structure-modify",
    "StructureAutocomplete" = "structure-autocomplete",
    "Feed" = "feed",
    "IncomingPostback" = "incoming_postback",
    "OutgoingPostback" = "outgoing_postback",
}
export enum ConnectionFilterValidators {
    "Equals" = "equals",
    "NotEquals" = "not_equals",
    "IsTrue" = "is_true",
    "IsFalse" = "is_false",
    "IsLessThan" = "is_less_than",
    "IsLessThanOrEquals" = "is_less_than_or_equals",
    "IsGreaterThan" = "is_greater_than",
    "IsGreaterThanOrEquals" = "is_greater_than_or_equals",
    "IsBetween" = "is_between",
    "IsBetweenEquals" = "is_between_equals",
    "IsEmpty" = "is_empty",
    "IsNotEmpty" = "is_not_empty",
    "StartsWith" = "starts_with",
    "EndsWith" = "ends_with",
    "RegexMatch" = "regex_match",
    "RegexNotMatch" = "regex_not_match",
    "Contains" = "contains",
    "NotContains" = "not_contains",
}
export enum ConnectionPropertySystemName {
    "ExternalId" = "external_id",
    "RedirectUrl" = "redirect_url",
    "Price" = "price",
    "RedirectToken" = "redirect_token",
    "Action" = "action",
    "Type" = "type",
    "CommissionId" = "commission_id",
    "Value" = "value",
    "Commission" = "commission",
    "CommissionReplace" = "adv_commission",
    "Result" = "result",
    "Advs1" = "advs1",
    "Advs2" = "advs2",
    "Advs3" = "advs3",
    "Advs4" = "advs4",
    "Advs5" = "advs5",
    "Advs6" = "advs6",
    "Advs7" = "advs7",
    "Advs8" = "advs8",
    "Advs9" = "advs9",
    "Advs10" = "advs10",
}
export enum ConnectionSequenceStepConnectionType {
    "Wait" = "wait",
    "GoToStep" = "go-to-step",
    "DelayedStep" = "delayed-step",
}
export enum ConnectionSequenceStepLogModelType {
    "Integration" = "Integration",
    "IncomingPostback" = "IncomingPostback",
    "OutgoingPostback" = "OutgoingPostback",
    "FormStructure" = "FormStructure",
}
export enum ConnectionSequenceStepLogResult {
    "Approved" = "approved",
    "Pending" = "pending",
    "Rejected" = "rejected",
    "Error" = "error",
    "Unprocessed" = "-",
}
export enum ConnectionSequenceStepMeaningType {
    "Check" = "check",
    "Send" = "send",
    "Auth" = "auth",
    "Ping" = "ping",
    "Post" = "post",
    "Finish" = "finish",
    "Auction" = "auction",
    "PostSendVerification" = "postsend_verification",
}
export enum ConnectionSequenceStepModelType {
    "Integration" = "App\\Models\\Integration",
    "IncomingPostback" = "App\\Models\\IncomingPostback",
    "OutgoingPostback" = "App\\Models\\OutgoingPostback",
    "FormStructure" = "App\\Models\\FormStructure",
}
export enum ConnectionSequenceStepTargetStatus {
    "Done" = "done",
    "Running" = "running",
}
export enum ConnectionSequenceStepType {
    "SendRequest" = "send-request",
    "Wait" = "wait",
    "VerifyPhone" = "verify-phone",
}
export enum ConnectionTag {
    "SecondaryToken" = "secondary_token",
    "ConversionId" = "conversion_id",
    "ConversionEid" = "eid",
    "ConversionEidPcid" = "pcid",
    "IpAddress" = "ip_address",
    "UserAgentModel" = "user_agent_model",
    "Timestamp" = "timestamp",
    "CreatedDate" = "created_date",
    "OwnerId" = "owner_id",
    "AdvertiserId" = "advertiser_id",
    "OfferId" = "offer_id",
    "OfferName" = "offer_name",
    "ConversionParentId" = "parent_id",
    "ConversionParentEid" = "parent_eid",
    "AdvertiserName" = "advertiser_name",
    "OwnerName" = "owner_name",
    "OriginEid" = "origin_eid",
    "IntegrationName" = "integration_name",
    "ChannelName" = "channel_name",
    "ChannelVisibleName" = "channel_visible_name",
    "AffCID" = "affcid",
}
export enum ConversionApiCascadeResponseStatus {
    "Approved" = "approved",
    "Rejected" = "rejected",
    "Pending" = "pending",
}
export enum ConversionLogCategory {
    "Redirected" = "redirected",
    "Created" = "created",
    "CreatedChild" = "created_child",
    "Updated" = "updated",
    "Cascade" = "cascade",
    "AdvertiserResponse" = "advert_response",
    "CascadeResponse" = "cascade_response",
    "IncomingPostback" = "incoming_postback",
    "OutgoingPostback" = "outgoing_postback",
}
export enum ConversionLogSeverity {
    "Info" = "info",
    "Warning" = "warning",
    "Error" = "error",
}
export enum ConversionSource {
    "Link" = "link",
    "Iframe" = "iframe",
    "Api" = "api",
    "IncomingPostback" = "incoming-postback",
    "OutgoingPostback" = "outgoing-postback",
}
export enum ConversionStateInput {
    "OfferLink" = "offer_link",
    "Iframe" = "iframe",
    "API" = "api",
    "Cascade" = "cascade",
    "Commission" = "commission",
    "IncomingPostback" = "incoming_postback",
    "OutgoingPostback" = "outgoing_postback",
}
export enum ConversionStateReportGroupBy {
    "Hour" = "hour",
    "Day" = "day",
}
export enum ConversionStateStatus {
    "InvalidData" = "invalid_data",
    "Sold" = "sold",
    "Error" = "error",
    "New" = "new",
    "RefusedByValidation" = "refused_by_validation",
    "RefusedByFilter" = "refused_by_filter",
    "RefusedByCascade" = "refused_by_cascade",
    "Verification" = "verification",
    "InBid" = "in_bid",
    "Redirected" = "redirected",
    "NoActiveChannelFound" = "no_active_channel_found",
    "Cascade" = "cascade",
    "DuplicateAdvertiser" = "duplicate_advertiser",
    "EndpointNotAllowed" = "endpoint_not_allowed",
    "NoOfferLinkFound" = "no_offer_link_found",
}
export enum ConversionStateType {
    "Click" = "click",
    "Lead" = "lead",
    "Sale" = "sale",
    "Send" = "send",
    "View" = "view",
    "Prospect" = "prospect",
}
export enum ConversionTypeAction {
    "Nothing" = "nothing",
    "Redirect" = "redirect",
    "Cascade" = "cascade",
    "Json" = "json",
    "Test" = "test",
}
export enum CurrencyReconversionStatus {
    "Pending" = "pending",
    "Running" = "running",
    "Completed" = "completed",
    "Failed" = "failed",
}
export enum CustomDomainCategoryType {
    "Default" = "default",
    "Exclude" = "exclude",
    "Include" = "include",
}
export enum ExportExtensionEnum {
    "XLSX" = "xlsx",
    "CSV" = "csv",
    "TSQ" = "tsv",
    "PDF" = "pdf",
}
export enum ExternalFinalPageSettingUserType {
    "Include" = "include",
    "Exclude" = "exclude",
}
export enum FileType {
    "TenantLogo" = "tenant_logo",
    "TenantFavicon" = "tenant_favicon",
    "Invoice" = "invoice",
    "TestPDFFile" = "test_pdf_file",
    "OfferLogo" = "offer_logo",
}
export enum FilterType {
    "Equals" = "equals",
    "NotEquals" = "not_equals",
    "IsTrue" = "is_true",
    "IsFalse" = "is_false",
    "IsLessThan" = "is_less_than",
    "IsLessThanOrEquals" = "is_less_than_or_equals",
    "IsGreaterThan" = "is_greater_than",
    "IsGreaterThanOrEquals" = "is_greater_than_or_equals",
    "IsBetween" = "is_between",
    "IsBetweenEquals" = "is_between_equals",
    "IsEmpty" = "is_empty",
    "IsNotEmpty" = "is_not_empty",
    "StartsWith" = "starts_with",
    "EndsWith" = "ends_with",
    "RegexMatch" = "regex_match",
    "RegexNotMatch" = "regex_not_match",
    "Contains" = "contains",
    "NotContains" = "not_contains",
    "Always" = "always",
}
export enum FormContentSettingType {
    "Timer" = "TIMER",
    "SplitToColumns" = "SPLIT_TO_COLUMNS",
    "SplitToColumnsSubItem" = "SPLIT_TO_COLUMNS_SUB_ITEM",
    "Paper" = "PAPER",
    "InputGroup" = "INPUT_GROUP",
    "StyledBox" = "STYLED_BOX",
    "Image" = "IMAGE",
    "ContinueButton" = "CONTINUE_BUTTON",
    "TableWithAnotherModule" = "TABLE_WITH_ANOTHER_MODULE",
    "Title" = "TITLE",
    "Progress" = "PROGRESS",
    "MoneyFan" = "MONEY_FAN",
}
export enum FormContinueButtonConfigAction {
    "NextPage" = "next-page",
    "PreviousPage" = "previous-page",
    "GoToPage" = "go-to-page",
    "Submit" = "submit",
}
export enum FormContinueButtonConfigAlign {
    "Left" = "left",
    "Right" = "right",
    "Center" = "center",
}
export enum FormContinueButtonConfigStyle {
    "Basic" = "basic",
    "Arrows" = "arrows",
}
export enum FormFieldOverride {
    "VisibleDescription" = "visible_description",
    "DocNote" = "doc_note",
    "IsRequired" = "is_required",
    "IsHidden" = "is_hidden",
    "DefaultValue" = "default_value",
    "ExampleValue" = "example_value",
    "Placeholder" = "placeholder",
    "NotShowIfSystemNameEquals" = "not_show_if_system_name_equals",
    "ShowOnlyIfSystemNameEquals" = "show_only_if_system_name_equals",
    "ValidationRegex" = "validation_regex",
    "FrontendFormat" = "frontend_format",
    "Range" = "range",
    "FormFieldSelectItems" = "form_field_select_items",
    "FormFieldRadioValues" = "form_field_radio_values",
    "ValidationScenarios" = "validation_scenarios",
    "ModificationScenarios" = "modification_scenarios",
    "AutocompleteScenarios" = "autocomplete_scenarios",
    "DataModificationAccessor" = "data_modification_accessor",
    "AutocompleteAccessor" = "autocomplete_accessor",
}
export enum FormFieldTypes {
    "Text" = "text",
    "LongText" = "long-text",
    "Number" = "number",
    "Phone" = "phone",
    "Email" = "email",
    "Date" = "date",
    "Country" = "country",
    "Currency" = "currency",
    "FinType" = "fin-type",
    "Checkbox" = "checkbox",
    "CheckboxAccordeon" = "checkbox-accordeon",
    "Select" = "select",
    "MultiSelect" = "multi-select",
    "Radio" = "radio",
    "MultiRadio" = "multi-radio",
    "TagInput" = "tag-input",
    "ListInput" = "list-input",
    "DelimitedInput" = "delimited-input",
    "Range" = "range",
    "Item" = "item",
    "Asset" = "asset",
}
export enum FormSplitConfigWrap {
    "Never" = "never",
    "VerticalOnPhone" = "vertical-on-phone",
}
export enum FormStructureCustomFieldType {
    "Information" = "information",
    "Rule" = "rule",
}
export enum FormStructureType {
    "Lead" = "lead",
    "User" = "user",
}
export enum FormStyledBoxAlign {
    "Left" = "left",
    "Right" = "right",
    "Center" = "center",
}
export enum FormTheme {
    "Material" = "material",
    "Theme1" = "theme1",
}
export enum FormTitleSettingAlign {
    "Center" = "center",
    "Left" = "left",
    "Right" = "right",
}
export enum FormTitleSettingSource {
    "CustomText" = "customText",
    "HeaderText" = "headerText",
    "GetMoneyText" = "getMoneyText",
    "TextUnderSubmit" = "textUnderSubmit",
}
export enum FormTitleSettingStyle {
    "Body1" = "body1",
    "Body2" = "body2",
    "Button" = "button",
    "Caption" = "caption",
    "H1" = "h1",
    "H2" = "h2",
    "H3" = "h3",
    "H4" = "h4",
    "H5" = "h5",
    "H6" = "h6",
    "Overline" = "overline",
    "Subtitle1" = "subtitle1",
    "Subtitle2" = "subtitle2",
}
export enum FormulaType {
    "Fix" = "fix",
    "Formula" = "formula",
    "Percent" = "percent",
    "PercentValue" = "percent_value",
    "PercentParent" = "percent_parent",
}
export enum HttpConvertType {
    "EMPTY_STRING_TO_NULL" = "empty_string_to_null",
    "NULL_TO_EMPTY_STRING" = "null_to_empty_string",
    "NONEXIST_TO_NULL" = "nonexist_to_null",
    "NONEXIST_TO_EMPTY_STRING" = "nonexist_to_empty_string",
    "EMPTY_STRING_NONEXIST_TO_NULL" = "empty_string_nonexist_to_null",
    "NULL_NONEXIST_TO_EMPTY_STRING" = "null_nonexist_to_empty_string",
}
export enum HttpNotSendType {
    "NULL" = "null",
    "EMPTY_STRING" = "empty_string",
    "NONEXIST" = "nonexist",
    "NULL_EMPTY_STRING" = "null_empty_string",
    "NONEXIST_EMPTY_STRING" = "nonexist_empty_string",
    "NULL_NONEXIST" = "null_nonexist",
    "NULL_NONEXIST_EMPTY_STRING" = "null_nonexist_empty_string",
}
export enum HttpSignatureDataDelimiterType {
    "AMPERSAND" = "&",
    "PIPE" = "|",
    "DOT" = ".",
}
export enum HttpSignatureType {
    "MD5_VALUES_SECRET" = "md5_values_secret",
    "MD5_SECRET_VALUES" = "md5_secret_values",
    "MD5_SORTED_VALUES_SECRET" = "md5_sorted_values_secret",
    "MD5_SECRET_SORTED_VALUES" = "md5_secret_sorted_values",
    "MD5_KEYVAL_SECRET" = "md5_keyval_secret",
    "MD5_SECRET_KEYVAL" = "md5_secret_keyval",
    "MD5_SORTED_KEYVAL_SECRET" = "md5_sorted_keyval_secret",
    "MD5_SECRET_SORTED_KEYVAL" = "md5_secret_sorted_keyval",
    "HMAC_BODY_SHA256" = "hmac_body_sha256",
    "HMAC_BODY_SHA512" = "hmac_body_sha512",
    "HMAC_TIMESTAMP_BODY_SHA256" = "hmac_timestamp_body_sha256",
    "HMAC_TIMESTAMP_BODY_SHA512" = "hmac_timestamp_body_sha512",
    "HMAC_TIMESTAMP_JSON_SHA256" = "hmac_timestamp_json_sha256",
    "HMAC_TIMESTAMP_JSON_SHA512" = "hmac_timestamp_json_sha512",
    "HMAC_RFC7231_BODY_SHA256" = "hmac_rfc7231_body_sha256",
    "HMAC_RFC7231_BODY_SHA512" = "hmac_rfc7231_body_sha512",
    "HMAC_SORTED_KEYVAL_SHA256" = "hmac_sorted_keyval_sha256",
    "HMAC_SORTED_KEYVAL_SHA512" = "hmac_sorted_keyval_sha512",
    "HMAC_QSORTED_KEYVAL_NONCE_BODYHASH_SHA256" = "hmac_qsorted_keyval_nonce_bodyhash_sha256",
    "HMAC_QSORTED_KEYVAL_NONCE_BODYHASH_SHA512" = "hmac_qsorted_keyval_nonce_bodyhash_sha512",
    "DIGEST_BASE64_SHA256" = "digest_base64_sha256",
    "DIGEST_BASE64_SHA512" = "digest_base64_sha512",
    "DIGEST_KEYID_HMAC_SHA256" = "digest_keyid_hmac_sha256",
    "DIGEST_KEYID_HMAC_SHA512" = "digest_keyid_hmac_sha512",
}
export enum IncomingPostbackAction {
    "Create" = "create",
    "Update" = "update",
}
export enum IncomingPostbackFormat {
    "Json" = "json",
}
export enum IncomingPostbackHttpMethod {
    "Post" = "POST",
}
export enum IncomingPostbackTransactionType {
    "Reward" = "reward",
    "Revenue" = "revenue",
    "Bonus" = "bonus",
    "Expense" = "expense",
    "Penalty" = "penalty",
}
export enum IntegrationStatus {
    "Creating" = "creating",
    "Testing" = "testing",
    "Ready" = "ready",
    "Stopped" = "stopped",
}
export enum InvoiceStatus {
    "Pending" = "pending",
    "Paid" = "paid",
    "Approved" = "approved",
    "Rejected" = "rejected",
    "Blocked" = "blocked",
    "BlockedAffiliate" = "blocked_affiliate",
}
export enum KeyType {
    "ConversionsApi" = "conversions_api",
    "Integration" = "integration",
    "FormStructure" = "form_structure",
    "Tracking" = "tracking",
    "Personal" = "personal",
}
export enum LabelType {
    "Label" = "label",
    "Category" = "category",
}
export enum LogSeverity {
    "Debug" = "debug",
    "Info" = "info",
    "Warning" = "warning",
    "Error" = "error",
    "Critical" = "critical",
}
export enum ModifyType {
    "ToFloat" = "to_float",
    "ToBool" = "to_bool",
    "ToInt" = "to_int",
    "ToString" = "to_string",
    "Replace" = "replace",
    "Math" = "math",
    "DateToUnix" = "unix",
    "AddPrefix" = "prefix",
    "AddPostfix" = "postfix",
    "FirstRegexMatch" = "first_regex_match",
    "DoNotSend" = "do_not_send",
    "FormatDate" = "format_date",
    "ModifyDate" = "modify_date",
    "CzNinToBirthdate" = "cz_nin_to_birthdate",
    "CzNinToGender" = "cz_nin_to_gender",
    "ToBase64" = "to_base64",
    "FromBase64" = "from_base64",
    "RegexReplace" = "regex_replace",
}
export enum OfferAccess {
    "Public" = "public",
    "Restricted" = "restricted",
    "Private" = "private",
}
export enum OfferBalanceAffiliateBilling {
    "TenantSetting" = "tenant_setting",
    "UninvoicedBalance" = "uninvoiced_balance",
    "InvoicedBalance" = "invoiced_balance",
    "ApprovedBalance" = "approved_balance",
    "PaidBalance" = "paid_balance",
}
export enum OfferCustomFieldType {
    "Information" = "information",
    "Rule" = "rule",
}
export enum OfferStatus {
    "Enabled" = "enabled",
    "Disabled" = "disabled",
}
export enum OutgoingPostbackAction {
    "Create" = "create",
    "Update" = "update",
}
export enum OutgoingPostbackParameter {
    "SubId" = "subId",
    "Id" = "id",
    "IsFromCascade" = "isFromCascade",
    "Currency" = "currency",
    "Payout" = "payout",
    "SaleAmount" = "saleAmount",
    "RefuseReason" = "refuseReason",
    "OfferId" = "offerId",
    "OfferName" = "offerName",
    "AffiliateId" = "affiliateId",
    "AffiliateName" = "affiliateName",
    "DistributionType" = "distributionType",
    "Category" = "category",
    "LeadType" = "leadType",
    "LeadStatus" = "leadStatus",
    "AffiliateLeadId" = "affiliateLeadId",
}
export enum OutgoingPostbackTrigger {
    "ConversionPayoutAll" = "conversion_payout_all",
    "ConversionPayoutCreated" = "conversion_payout_created",
    "ConversionPayoutUpdated" = "conversion_payout_updated",
}
export enum PaymentMethodType {
    "Card" = "card",
}
export enum PayoutResult {
    "Approved" = "approved",
    "Rejected" = "rejected",
    "Pending" = "pending",
}
export enum PayoutResultAll {
    "Approved" = "approved",
    "Rejected" = "rejected",
    "Pending" = "pending",
    "All" = "all",
}
export enum PayoutType {
    "Prospect" = "prospect",
    "Sale" = "sale",
}
export enum PerformanceReportDataSourceEnum {
    "ReportPayoutPerformances" = "ReportPayoutPerformances",
    "ReportPerformances" = "ReportPerformances",
}
export enum PerformanceReportViewEnum {
    "TenantAdmin" = "TenantAdmin",
    "AffiliatePartner" = "AffiliatePartner",
}
export enum PermissionEnum {
    "AddressView" = "address_view",
    "AddressCreate" = "address_create",
    "AddressUpdate" = "address_update",
    "AddressDelete" = "address_delete",
    "AffiliateManage" = "affiliate_manage",
    "AffiliateDetailView" = "affiliate_detail_view",
    "AffiliateDetailEdit" = "affiliate_detail_edit",
    "AffiliateDetailLinkView" = "affiliate_detail_link_view",
    "AffiliateTransactionView" = "affiliate_transaction_view",
    "AffiliateTransactionEdit" = "affiliate_transaction_edit",
    "AffiliateCommissionTierView" = "affiliate_commission_tier_view",
    "AffiliateCommissionTierEdit" = "affiliate_commission_tier_edit",
    "AffiliateCommissionCurrentTierView" = "affiliate_commission_current_tier_view",
    "AffiliateCommissionCurrentTierEdit" = "affiliate_commission_current_tier_edit",
    "AffiliatePayoutView" = "affiliate_payout_view",
    "AffiliatePayoutEdit" = "affiliate_payout_edit",
    "AffiliateOfferRequestsView" = "affiliate_offer_requests_view",
    "AffiliateEntryEdit" = "affiliate_entry_edit",
    "AdvertiserManage" = "advertiser_manage",
    "AdvertiserDetailView" = "advertiser_detail_view",
    "AdvertiserDetailEdit" = "advertiser_detail_edit",
    "AdvertiserDetailLinkView" = "advertiser_detail_link_view",
    "AdvertiserTransactionView" = "advertiser_transaction_view",
    "AdvertiserTransactionEdit" = "advertiser_transaction_edit",
    "AdvertiserCommissionView" = "advertiser_commission_view",
    "AdvertiserCommissionEdit" = "advertiser_commission_edit",
    "AdvertiserPayoutView" = "advertiser_payout_view",
    "AdvertiserPayoutEdit" = "advertiser_payout_edit",
    "AdvertiserEntryView" = "advertiser_entry_view",
    "AdvertiserEntryEdit" = "advertiser_entry_edit",
    "DocumentationShow" = "documentation_show",
    "SubscriptionsView" = "subscriptions_view",
    "SubscriptionCreate" = "subscription_create",
    "SubscriptionSuccess" = "subscription_success",
    "SubscriptionCancel" = "subscription_cancel",
    "OfferView" = "offer_view",
    "OfferViewAccessUnrestricted" = "offer_view_access_unrestricted",
    "OfferViewForeign" = "offer_view_foreign",
    "OfferViewDisabled" = "offer_view_disabled",
    "OfferCreate" = "offer_create",
    "OfferUpdate" = "offer_update",
    "OfferDelete" = "offer_delete",
    "OfferPin" = "offer_pin",
    "OfferExport" = "offer_export",
    "OfferImport" = "offer_import",
    "OfferDownload" = "offer_download",
    "OfferAddAdvertiser" = "offer_add_advertiser",
    "OfferAddAffiliate" = "offer_add_affiliate",
    "OfferIframeView" = "offer_iframe_view",
    "OfferIframeOwn" = "offer_iframe_view_own",
    "OfferIframeOthers" = "offer_iframe_view_others",
    "OfferApiView" = "offer_api_view",
    "OfferApiViewOwn" = "offer_api_view_own",
    "OfferApiViewOthers" = "offer_api_view_others",
    "OfferApiRegenerateOwnToken" = "offer_api_regenerate_own_token",
    "OfferApiRegenerateForeignToken" = "offer_api_regenerate_foreign_token",
    "OfferEditDefault" = "offer_edit_default",
    "OfferEditLink" = "offer_edit_link",
    "OfferEditIframe" = "offer_edit_iframe",
    "OfferEditApi" = "offer_edit_api",
    "OfferEditFilters" = "offer_edit_filters",
    "OfferEditCascade" = "offer_edit_cascade",
    "OfferCustomFieldView" = "offer_custom_field_view",
    "OfferCustomFieldCreate" = "offer_custom_field_create",
    "OfferCustomFieldUpdate" = "offer_custom_field_update",
    "OfferCustomFieldDelete" = "offer_custom_field_delete",
    "OfferLinkView" = "offer_link_view",
    "OfferLinkViewOwn" = "offer_link_view_own",
    "OfferLinkViewOthers" = "offer_link_view_others",
    "OfferLinkCreate" = "offer_link_create",
    "OfferLinkUpdate" = "offer_link_update",
    "OfferLinkDelete" = "offer_link_delete",
    "RefuseLeadSettingsView" = "refuse_lead_setting_view",
    "RefuseLeadSettingsCreate" = "refuse_lead_setting_create",
    "RefuseLeadSettingsUpdate" = "refuse_lead_setting_update",
    "RefuseLeadSettingsDelete" = "refuse_lead_setting_delete",
    "ProcessRefuseLeadSettingsView" = "process_refuse_lead_setting_view",
    "ProcessRefuseLeadSettingsCreate" = "process_refuse_lead_setting_create",
    "ProcessRefuseLeadSettingsUpdate" = "process_refuse_lead_setting_update",
    "ProcessRefuseLeadSettingsDelete" = "process_refuse_lead_setting_delete",
    "ExternalFinalPageSettingView" = "external_final_page_setting_view",
    "ExternalFinalPageSettingCreate" = "external_final_page_setting_create",
    "ExternalFinalPageSettingUpdate" = "external_final_page_setting_update",
    "ExternalFinalPageSettingDelete" = "external_final_page_setting_delete",
    "CommissionView" = "commission_view",
    "CommissionOverviewStatusView" = "commission_overview_status_view",
    "CommissionOverviewCommissionGroupView" = "commission_overview_commission_group_view",
    "CommissionUpdate" = "commission_update",
    "CommissionCreate" = "commission_create",
    "CommissionDelete" = "commission_delete",
    "CommissionDownload" = "commission_download",
    "CommissionForeignGroupView" = "commission_foreign_group_view",
    "CommissionForeignOfferView" = "commission_foreign_offer_view",
    "CommissionTypeTenant" = "commission_type_tenant",
    "CommissionFormulaPercentValue" = "commission_formula_percent_value",
    "DashboardView" = "dashboard_view",
    "DashboardEdit" = "dashboard_edit",
    "DashboardTopOfferView" = "dashboard_top_offer_view",
    "DashboardTopPartnerView" = "dashboard_top_partner_view",
    "DashboardNewAccountView" = "dashboard_new_account_view",
    "DashboardWorkspaceRequestsView" = "dashboard_workspace_requests_view",
    "DashboardOfferRequestsView" = "dashboard_offer_requests_view",
    "DashboardAffiliatePayoutsView" = "dashboard_affiliate_payouts_view",
    "DashboardAdvertiserPayoutsView" = "dashboard_advertiser_payouts_view",
    "DashboardDailyOverviewView" = "dashboard_daily_overview_view",
    "DashboardLatestConversionsView" = "dashboard_latest_conversions_view",
    "DashboardInvitePartnersView" = "dashboard_invite_partners_view",
    "DashboardUniqueLinkView" = "dashboard_unique_link_view",
    "PayoutView" = "payout_view",
    "PayoutViewForeign" = "payout_view_foreign",
    "PayoutCreate" = "payout_create",
    "PayoutUpdate" = "payout_update",
    "PayoutImport" = "payout_import",
    "PayoutDownload" = "payout_download",
    "PayoutLogView" = "payout_log_view",
    "BalanceView" = "balance_view",
    "BalanceViewForeign" = "balance_view_foreign",
    "CascadeView" = "cascade_view",
    "CascadeUpdate" = "cascade_update",
    "CascadeCreate" = "cascade_create",
    "CascadeDelete" = "cascade_delete",
    "CascadeLogView" = "cascade_log_view",
    "CascadeLogDownload" = "cascade_log_download",
    "ConnectionSequenceStepShow" = "connection_sequence_step_show",
    "ConnectionSequenceStepUpdate" = "connection_sequence_step_update",
    "ConnectionSequenceStepDelete" = "connection_sequence_step_delete",
    "IntegrationConnectionSequenceStepsExport" = "integration_connection_sequence_steps_export",
    "IntegrationConnectionSequenceStepsUpdate" = "integration_connection_sequence_steps_update",
    "ConnectionSequenceStepsConnectionView" = "connection_sequence_steps_connection_view",
    "ConnectionSequenceStepsConnectionUpdate" = "connection_sequence_steps_connection_update",
    "ConnectionSequenceStepsConnectionCreate" = "connection_sequence_steps_connection_create",
    "ConnectionSequenceStepsConnectionDelete" = "connection_sequence_steps_connection_delete",
    "ContactsView" = "contacts_view",
    "ContactsUpdate" = "contacts_update",
    "ContactsCreate" = "contacts_create",
    "ContactsDelete" = "contacts_delete",
    "ConversionLogView" = "conversion_log_view",
    "ConversionLogDetailView" = "conversion_log_detail_view",
    "ConversionLogFormValuesView" = "conversion_log_form_values_view",
    "ConversionConversionLogView" = "conversion_conversion_log_view",
    "ConversionConversionLogDetailView" = "conversion_conversion_log_detail_view",
    "ConversionLeadLogView" = "conversion_lead_log_view",
    "ConversionLeadLogDetailView" = "conversion_lead_log_detail_view",
    "ConversionClickLogView" = "conversion_click_log_view",
    "ConversionClickLogDetailView" = "conversion_click_log_detail_view",
    "ConversionStateView" = "conversion_state_view",
    "ConversionStateForeign" = "conversion_state_foreign",
    "ConversionStateDownload" = "conversion_state_download",
    "ConnectionSequenceStepView" = "connection_sequence_step_view",
    "ConnectionSequenceStepForeign" = "connection_sequence_step_foreign",
    "ConnectionSequenceStepCreate" = "connection_sequence_step_create",
    "ConnectionSequenceStepLogsView" = "connection_sequence_step_logs_view",
    "ConnectionSequenceStepLogForeign" = "connection_sequence_step_logs_foreign",
    "ConnectionSequenceStepLogsDownload" = "connection_sequence_step_logs_download",
    "CommissionGroupView" = "commission_group_view",
    "CommissionGroupViewForeign" = "commission_group_view_foreign",
    "CommissionGroupPageView" = "commission_group_page_view",
    "CommissionGroupUpdate" = "commission_group_update",
    "CommissionGroupCreate" = "commission_group_create",
    "CommissionGroupDelete" = "commission_group_delete",
    "CommissionGroupDownload" = "commission_group_download",
    "ConversionTypeView" = "conversion_type_view",
    "ConversionTypeSelect" = "conversion_type_select",
    "CustomDomainView" = "custom_domain_view",
    "CustomDomainUpdate" = "custom_domain_update",
    "CustomDomainCreate" = "custom_domain_create",
    "CustomDomainDelete" = "custom_domain_delete",
    "FileCreate" = "file_create",
    "FileTenantLogo" = "file_tenant_logo",
    "FileTenantFavicon" = "file_tenant_favicon",
    "FormView" = "form_view",
    "FormUpdate" = "form_update",
    "FormCreate" = "form_create",
    "FormDelete" = "form_delete",
    "FormDownload" = "form_download",
    "GlobalFormFieldView" = "global_form_field_view",
    "GlobalFormFieldStore" = "global_form_field_store",
    "GlobalFormFieldUpdate" = "global_form_field_update",
    "GlobalFormFieldDelete" = "global_form_field_delete",
    "FormFieldView" = "form_field_view",
    "FormFieldStore" = "form_field_store",
    "FormFieldUpdate" = "form_field_update",
    "FormFieldDelete" = "form_field_delete",
    "ModelTranslationView" = "model_translation_view",
    "ModelTranslationStore" = "model_translation_store",
    "ModelTranslationUpdate" = "model_translation_update",
    "ModelTranslationDelete" = "model_translation_delete",
    "KeyView" = "key_view",
    "KeyViewForeign" = "key_view_foreign",
    "KeyStore" = "key_store",
    "KeyUpdate" = "key_update",
    "KeyDelete" = "key_delete",
    "FormStructureView" = "form_structure_view",
    "FormStructureUpdate" = "form_structure_update",
    "FormStructureCreate" = "form_structure_create",
    "FormStructureDelete" = "form_structure_delete",
    "FormStructureClone" = "form_structure_clone",
    "FormStructureDownload" = "form_structure_download",
    "FormStructureCustomFieldView" = "form_structure_custom_field_view",
    "FormStructureCustomFieldCreate" = "form_structure_custom_field_create",
    "FormStructureCustomFieldUpdate" = "form_structure_custom_field_update",
    "FormStructureCustomFieldDelete" = "form_structure_custom_field_delete",
    "IncomingPostbackView" = "incoming_postback_view",
    "IncomingPostbackForeign" = "incoming_postback_foreign",
    "IncomingPostbackUpdate" = "incoming_postback_update",
    "IncomingPostbackCreate" = "incoming_postback_create",
    "IncomingPostbackDelete" = "incoming_postback_delete",
    "IncomingPostbackExport" = "incoming_postback_export",
    "IncomingPostbackDownload" = "incoming_postback_download",
    "IncomingPostbackConnectionSequenceStepsExport" = "incoming_postback_connection_sequence_steps_export",
    "IncomingPostbackConnectionSequenceStepsUpdate" = "incoming_postback_connection_sequence_steps_update",
    "IncomingPostbackLogView" = "incoming_postback_log_view",
    "IncomingPostbackLogDownload" = "incoming_postback_log_download",
    "StepLogIntegrationsView" = "step_log_integrations_view",
    "StepLogIncomingPostbacksView" = "step_log_incoming_postbacks_view",
    "StepLogIncomingPostbacksDownload" = "step_log_incoming_postbacks_download",
    "StepLogOutgoingPostbacksView" = "step_log_outgoing_postbacks_view",
    "StepLogOutgoingPostbacksDownload" = "step_log_outgoing_postbacks_download",
    "StepLogStructuresView" = "step_log_structures_view",
    "StepLogStructuresDownload" = "step_log_structures_download",
    "IntegrationView" = "integration_view",
    "IntegrationUpdate" = "integration_update",
    "IntegrationCreate" = "integration_create",
    "IntegrationDelete" = "integration_delete",
    "IntegrationExport" = "integration_export",
    "IntegrationDownload" = "integration_download",
    "IntegrationCustomFieldView" = "integration_custom_field_view",
    "IntegrationCustomFieldUpdate" = "integration_custom_field_update",
    "IntegrationCustomFieldCreate" = "integration_custom_field_create",
    "IntegrationCustomFieldDelete" = "integration_custom_field_delete",
    "InvoiceView" = "invoice_view",
    "InvoiceViewForeign" = "invoice_view_foreign",
    "InvoiceUpdate" = "invoice_update",
    "InvoiceCreate" = "invoice_create",
    "InvoiceDelete" = "invoice_delete",
    "InvoiceDownload" = "invoice_download",
    "InvoiceMinimumAmountView" = "invoice_minimum_amount_view",
    "InvoiceMinimumAmountCreate" = "invoice_minimum_amount_create",
    "InvoiceMinimumAmountUpdate" = "invoice_minimum_amount_update",
    "InvoiceMinimumAmountDelete" = "invoice_minimum_amount_delete",
    "ManagerFormFieldView" = "manager_form_field_view",
    "OutgoingPostbackView" = "outgoing_postback_view",
    "OutgoingPostbackForeign" = "outgoing_postback_foreign",
    "OutgoingPostbackSetOwner" = "outgoing_postback_set_owner",
    "OutgoingPostbackSetAffiliate" = "outgoing_postback_set_affiliate",
    "OutgoingPostbackSetAdvertiser" = "outgoing_postback_set_advertiser",
    "OutgoingPostbackSetIntegration" = "outgoing_postback_set_integration",
    "OutgoingPostbackSetChannel" = "outgoing_postback_set_channel",
    "OutgoingPostbackUpdate" = "outgoing_postback_update",
    "OutgoingPostbackCreate" = "outgoing_postback_create",
    "OutgoingPostbackDelete" = "outgoing_postback_delete",
    "OutgoingPostbackExport" = "outgoing_postback_export",
    "OutgoingPostbackDownload" = "outgoing_postback_download",
    "OutgoingPostbackConnectionSequenceStepsExport" = "outgoing_postback_connection_sequence_steps_export",
    "OutgoingPostbackConnectionSequenceStepsUpdate" = "outgoing_postback_connection_sequence_steps_update",
    "OutgoingPostbackLogView" = "outgoing_postback_log_view",
    "OutgoingPostbackLogDownload" = "outgoing_postback_log_download",
    "OutgoingPostbackLogViewOutput" = "outgoing_postback_log_view_output",
    "OutgoingPostbackLogViewAdvertiser" = "outgoing_postback_log_view_advertiser",
    "OutgoingPostbackViewOwner" = "outgoing_postback_view_owner",
    "ToolTrackingOutgoingPostbackExportView" = "tool_tracking_outgoing_export_view",
    "ToolTrackingOutgoingPostbackExportSave" = "tool_tracking_outgoing_export_save",
    "ToolTrackingOutgoingPostbackEditorExportView" = "tool_tracking_outgoing_editor_export_view",
    "ToolTrackingOutgoingPostbackEditorExportSave" = "tool_tracking_outgoing_editor_export_save",
    "PaymentMethodsView" = "payment_methods_view",
    "PaymentMethodsCreate" = "payment_methods_create",
    "PaymentMethodsUpdate" = "payment_methods_update",
    "PaymentMethodsDelete" = "payment_methods_delete",
    "PaymentMethodsSetupIndent" = "payment_methods_setup_indent",
    "UserRequestView" = "user_request_view",
    "UserRequestViewForeign" = "user_request_view_foreign",
    "UserRequestUpdate" = "user_request_update",
    "UserRequestCreate" = "user_request_create",
    "UserRequestDownload" = "user_request_download",
    "RoleView" = "role_view",
    "RoleViewForeign" = "role_view_foreign",
    "UserLabelsView" = "user_labels_view",
    "ReportPerformance" = "report_performance",
    "ReportPerformanceDownload" = "report_performance_download",
    "ReportAffiliate" = "report_affiliate",
    "ReportAffiliateDownload" = "report_affiliate_download",
    "ReportOffer" = "report_offer",
    "ReportTransaction" = "report_transaction",
    "ReportOfferDownload" = "report_offer_download",
    "ReportAdvertiser" = "report_advertiser",
    "ReportAdvertiserDownload" = "report_advertiser_download",
    "ReportCascade" = "report_cascade",
    "ReportCascadeView" = "report_cascade_view",
    "ReportCascadeDownload" = "report_cascade_download",
    "ReportConversion" = "report_conversion",
    "ReportEvent" = "report_event",
    "ReportForeignPerformance" = "report_foreign_performance",
    "ReportForeignAffiliate" = "report_foreign_affiliate",
    "ReportForeignAdvertiser" = "report_foreign_advertiser",
    "ReportForeignOffer" = "report_foreign_offer",
    "ReportAddHighlight" = "report_add_highlight",
    "ReportSelectFilterTime" = "report_select_filter_time",
    "ReportSelectFilter" = "report_select_filter",
    "ReportRelativeSwitch" = "report_relative_switch",
    "ReportDownload" = "report_download",
    "ReportUpdate" = "report_update",
    "ReportColumnSetting" = "report_column_setting",
    "ReportPageSetting" = "report_page_setting",
    "ReportShowInGraph" = "report_show_in_graph",
    "SettingsView" = "settings_view",
    "SettingsUpdate" = "settings_update",
    "SettingsCreate" = "settings_create",
    "SettingsDelete" = "settings_delete",
    "WorkspaceCurrencyUpdate" = "workspace_currency_update",
    "TenantUserView" = "tenant_user_index",
    "TenantUserViewForeign" = "tenant_user_view_foreign",
    "TenantUserDownload" = "tenant_user_download",
    "TenantUserAssignRoles" = "tenant_user_assign_roles",
    "TenantUserSetCommissionGroups" = "tenant_user_set_commission_groups",
    "TenantUserKick" = "tenant_user_kick",
    "TenantUserBlock" = "tenant_user_block",
    "TenantUserSettingsUpdate" = "tenant_user_setting_update",
    "TenantUserSettingsViewForeign" = "tenant_user_setting_view_foreign",
    "TenantUserSettingsCreateForeign" = "tenant_user_setting_store_foreign",
    "TenantUserSettingsUpdateForeign" = "tenant_user_setting_update_foreign",
    "TenantUserSettingsDeleteForeign" = "tenant_user_setting_delete_foreign",
    "TenantView" = "tenant_view",
    "TenantUpdate" = "tenant_update",
    "TenantCreate" = "tenant_create",
    "TenantDelete" = "tenant_delete",
    "TenantForceDelete" = "tenant_force_delete",
    "TenantRestore" = "tenant_restore",
    "TenantLeave" = "tenant_leave",
    "UsersView" = "users_view",
    "UserView" = "user_view",
    "UserUpdate" = "user_update",
    "UserCreate" = "user_create",
    "PartnerView" = "partner_view",
    "UsersInvitationsView" = "users_invitations_view",
    "UserInvitationsView" = "user_invitations_view",
    "UserInvitationsCreate" = "user_invitations_create",
    "TenantSettingView" = "tenant_setting_view",
    "TenantSettingEdit" = "tenant_setting_edit",
    "TenantSettingDelete" = "tenant_setting_delete",
    "ToolStructureForm" = "tool_structure_form",
    "ToolStructureFormGeneral" = "tool_structure_form_general",
    "ToolStructureFormStructure" = "tool_structure_form_structure",
    "ToolStructureFormEditor" = "tool_structure_form_editor",
    "ToolStructureUser" = "tool_structure_user",
    "ToolStructureUserGeneral" = "tool_structure_user_general",
    "ToolStructureUserStructure" = "tool_structure_user_structure",
    "ToolStructureUserEdit" = "tool_structure_user_edit",
    "ToolStructureFeed" = "tool_structure_feed",
    "ToolStructureFeedGeneral" = "tool_structure_feed_general",
    "ToolStructureFeedStructure" = "tool_structure_feed_structure",
    "ToolStructureFeedEditor" = "tool_structure_feed_editor",
    "ToolIntegration" = "tool_integration",
    "ToolIntegrationGeneral" = "tool_integration_general",
    "ToolIntegrationExportView" = "tool_integration_export_view",
    "ToolIntegrationExportSave" = "tool_integration_export_save",
    "ToolIntegrationEditor" = "tool_integration_editor",
    "ToolIntegrationEditorExportView" = "tool_integration_editor_export_view",
    "ToolIntegrationEditorExportSave" = "tool_integration_editor_export_save",
    "ToolScenarioField" = "tool_scenario_field",
    "ToolScenarioFieldGeneral" = "tool_scenario_field_general",
    "ToolScenarioFieldEditor" = "tool_scenario_field_editor",
    "ToolDesignForm" = "tool_design_form",
    "ToolDesignFormGeneral" = "tool_design_form_general",
    "ToolDesignFormEditor" = "tool_design_form_editor",
    "ToolDesignScreen" = "tool_design_screen",
    "ToolDesignScreenGeneral" = "tool_design_screen_general",
    "ToolDesignScreenEditor" = "tool_design_screen_editor",
    "ToolDesignFunnel" = "tool_design_funnel",
    "ToolDesignFunnelGeneral" = "tool_design_funnel_general",
    "ToolDesignFunnelEditor" = "tool_design_funnel_editor",
    "ToolTrackingIncoming" = "tool_tracking_incoming",
    "ToolTrackingIncomingEditGeneral" = "tool_tracking_incoming_edit_general",
    "ToolTrackingIncomingEditEditor" = "tool_tracking_incoming_edit_editor",
    "ToolTrackingIncomingPostbackExportView" = "tool_tracking_incoming_export_view",
    "ToolTrackingIncomingPostbackExportSave" = "tool_tracking_incoming_export_save",
    "ToolTrackingIncomingPostbackEditorExportView" = "tool_tracking_incoming_editor_export_view",
    "ToolTrackingIncomingPostbackEditorExportSave" = "tool_tracking_incoming_editor_export_save",
    "ToolTrackingOutgoing" = "tool_tracking_outgoing",
    "ToolTrackingOutgoingEditGeneral" = "tool_tracking_outgoing_edit_general",
    "ToolTrackingOutgoingEditEditor" = "tool_tracking_outgoing_edit_editor",
    "FinanceCostView" = "finance_cost_view",
    "FinanceCostEdit" = "finance_cost_edit",
    "FinancePenaltyView" = "finance_penalty_view",
    "FinancePenaltyEdit" = "finance_penalty_edit",
    "FinanceRevenueView" = "finance_revenue_view",
    "FinanceRevenueEdit" = "finance_revenue_edit",
    "FinanceBonusView" = "finance_bonus_view",
    "FinanceBonusEdit" = "finance_bonus_edit",
    "SettingGeneral" = "setting_general",
    "SettingUser" = "setting_user",
    "SettingTracking" = "setting_tracking",
    "SettingTags" = "setting_tags",
    "SettingField" = "setting_field",
    "SettingPlan" = "setting_plan",
    "TagsReplaceWorkspaceAmount" = "tags_replace_workspace_amount",
    "TagsReplaceWorkspaceCurrency" = "tags_replace_workspace_currency",
    "LabelsView" = "labels_view",
    "LabelsCreate" = "labels_create",
    "LabelsUpdate" = "labels_update",
    "LabelsDelete" = "labels_delete",
    "LabelsDownload" = "labels_download",
    "LogChangesView" = "log_changes_view",
    "LogSelectFilterTime" = "log_select_filter_time",
    "LogSelectFilter" = "log_select_filter",
    "LogShowDetail" = "log_show_detail",
    "LogDownload" = "log_download",
    "LogUpdate" = "log_update",
    "LogColumnSetting" = "log_column_setting",
    "ApiLogsView" = "api_logs_view",
    "StructureLogsView" = "structure_logs_view",
    "ConnectionCreatorStepTypes" = "connection_creator_step_types",
    "ConnectionCreatorScenarioView" = "connection_creator_scenario_view",
    "ConnectionCreatorScenarioDetail" = "connection_creator_scenario_detail",
    "ConnectionCreatorScenarioCreate" = "connection_creator_scenario_create",
    "ConnectionCreatorScenarioUpdate" = "connection_creator_scenario_update",
    "ConnectionCreatorScenarioDelete" = "connection_creator_scenario_delete",
    "ConnectionCreatorScenarioGraphDraw" = "connection_creator_scenario_graph_draw",
    "ConnectionCreatorScenarioGraphView" = "connection_creator_scenario_graph_view",
    "ConnectionCreatorScenarioGraphUpdate" = "connection_creator_scenario_graph_update",
    "ConnectionCreatorStepDetail" = "connection_creator_step_detail",
    "ConnectionCreatorStepUpdate" = "connection_creator_step_update",
    "ConnectionCreatorScenarioRun" = "connection_creator_scenario_run",
    "ConnectionCreatorScenarioRunView" = "connection_creator_scenario_run_view",
    "ConnectionCreatorScenarioRunDetail" = "connection_creator_scenario_run_detail",
    "ConnectionCreatorLogView" = "connection_creator_log_view",
    "ConnectionCreatorLogDetail" = "connection_creator_log_detail",
}
export enum PhoneVerificationAction {
    "Send" = "send",
    "Resend" = "resend",
    "Verify" = "verify",
}
export enum PostbackLogOutput {
    "Unmatched" = "unmatched",
    "NoChange" = "no_change",
    "Filtered" = "filtered",
    "InProgress" = "in_progress",
    "Ok" = "ok",
    "Fail" = "fail",
}
export enum PropertyCheckOperator {
    "IsTrue" = "is-true",
    "Equals" = "equals",
    "NotEquals" = "not-equals",
    "IsFalse" = "is-false",
    "IsSmallerThan" = "is-smaller-than",
    "IsBiggerThan" = "is-bigger-than",
    "IsBetweenThan" = "is-between-than",
    "BetweenInclude" = "between-include",
    "StringNotContains" = "string-not-contains",
    "StringContains" = "string-contains",
    "StringEndsWith" = "string-ends-with",
    "StringStartsWith" = "string-starts-with",
    "IsEmpty" = "is-empty",
    "IsNotEmpty" = "is-not-empty",
    "Always" = "always",
    "RegexMatch" = "regex-match",
    "RegexNotMatch" = "regex-not-match",
}
export enum PropertyCheckSource {
    "Body" = "body",
    "Header" = "header",
    "HttpCode" = "httpCode",
}
export enum PropertyCheckType {
    "Basic" = "basic",
    "Object" = "object",
}
export enum PropertyModifyChangeFieldType {
    "LeadFromLead" = "load-from-lead",
}
export enum PropertyModifyChangeType {
    "ToFloat" = "to-float",
    "ToBool" = "to-bool",
    "ToInt" = "to-int",
    "Replace" = "replace",
    "Match" = "match",
    "DateToUnix" = "unix",
    "AddPrefix" = "prefix",
    "AddPostfix" = "postfix",
    "FirstRegexMatch" = "first-regex-match",
    "DoNotSend" = "do-not-send",
    "FormatDate" = "format-date",
    "ModifyDate" = "modify-date",
    "CzNinToBirthdate" = "cz-nin-to-birthdate",
    "CzNinToGender" = "cz-nin-to-gender",
    "ToBase64" = "to-base64",
    "FromBase64" = "from-base64",
    "LoadFromLead" = "load-from-lead",
    "RegexReplace" = "regex-replace",
}
export enum PropertyModifyConditionType {
    "Equals" = "equals",
    "IsTrue" = "is-true",
    "IsFalse" = "is-false",
    "NotEquals" = "not-equals",
    "BiggerThan" = "bigger-than",
    "SmallerThan" = "smaller-than",
    "StringContains" = "string-contains",
    "StringNotContains" = "string-not-contains",
    "StringEndsWith" = "string-ends-with",
    "StringStartsWith" = "string-starts-with",
    "Between" = "between",
    "BetweenInclude" = "between-include",
    "IsNotEmpty" = "is-not-empty",
    "IsEmpty" = "is-empty",
    "Always" = "always",
    "RegexMatch" = "regex-match",
    "RegexNotMatch" = "regex-not-match",
}
export enum PropertyModifyValueCompereType {
    "Value" = "value",
    "DataAccessor" = "data-accessor",
}
export enum RefuseLeadToUserType {
    "Include" = "include",
    "Exclude" = "exclude",
}
export enum RefuseLeadsType {
    "Validation" = "validation",
    "Filters" = "filters",
    "Cascade" = "cascade",
}
export enum RegistrationPasswordType {
    "WithoutPassword" = "without_password",
    "WithPassword" = "with_password",
}
export enum ReportOperator {
    "Increment" = "increment",
    "Decrement" = "decrement",
}
export enum ReportType {
    "CascadeTotal" = "cascade_total",
    "CascadeFiltered" = "cascade_filtered",
    "CascadeErrorCheck" = "cascade_error_check",
    "CascadeErrorVerify" = "cascade_error_verify",
    "CascadeErrorSend" = "cascade_error_send",
    "CascadeRefusedCheck" = "cascade_refused_check",
    "CascadeRefusedVerify" = "cascade_refused_verify",
    "CascadeRefusedSend" = "cascade_refused_send",
    "CascadeChecked" = "cascade_checked",
    "CascadeVerify" = "cascade_verify",
    "CascadeVerified" = "cascade_verified",
    "CascadeSend" = "cascade_send",
    "CascadeAccepted" = "cascade_accepted",
    "CascadeRedirected" = "cascade_redirected",
    "CascadeSales" = "cascade_sales",
    "CascadeRejected" = "cascade_rejected",
    "CascadeEPL" = "cascade_epl",
    "CascadeRevenue" = "cascade_revenue",
    "PerformanceClick" = "performance_click",
    "PerformanceLead" = "performance_lead",
    "PerformanceSend" = "performance_send",
    "PerformanceView" = "performance_view",
    "PerformanceSale" = "performance_sale",
    "PerformanceCost" = "performance_cost",
    "PerformanceRevenue" = "performance_revenue",
}
export enum RequestConnectionPropertyType {
    "Constant" = "constant",
    "Object" = "object",
    "Combine" = "combine",
    "Md5" = "md5",
}
export enum RequestEmptyFieldsBehaviorType {
    "DontSendNullEmpty" = "dont-send-null-empty",
    "ConvertNullToEmpty" = "convert-null-to-empty",
}
export enum RequestMethod {
    "Post" = "POST",
    "Put" = "PUT",
    "Delete" = "DELETE",
    "Get" = "GET",
    "Patch" = "PATCH",
}
export enum RequestPayloadType {
    "Json" = "json",
    "FormData" = "form-data",
    "XWwwFormUrlencoded" = "x-www-form-urlencoded",
    "XWwwFormUrlencodedPlusJsonData" = "x-www-form-urlencoded-plus-json-data",
    "LoginPassData" = "login-pass-data",
}
export enum ResponseHandlerResultMeaning {
    "Success" = "success",
    "Fail" = "fail",
}
export enum ResponsePropertySourceType {
    "Body" = "body",
    "Header" = "header",
    "HttpCode" = "httpCode",
    "Constant" = "constant",
    "Query" = "query",
}
export enum RoleEnum {
    "SuperAdmin" = "SuperAdmin",
    "User" = "User",
    "Guest" = "Guest",
    "AdminBeast" = "Admin Beast",
    "AdminPro" = "Admin Pro",
    "AdminPlus" = "Admin Plus",
    "AdminLite" = "Admin Lite",
    "AdminFree" = "Admin Free",
    "AdvertiserPro" = "Advertiser Pro",
    "AdvertiserPlus" = "Advertiser Plus",
    "Advertiser" = "Advertiser",
    "AdvertiserExtra" = "Advertiser Extra",
    "AffiliatePartner" = "AffiliatePartner",
    "AffiliateManager" = "AffiliateManager",
    "OfferManager" = "OfferManager",
    "Analytic" = "Analytic",
    "Viewer" = "Viewer",
    "It" = "IT",
    "Billing" = "Billing",
}
export enum SearchFilterEnum {
    "Like" = "like",
    "Ilike" = "ilike",
    "MultiIlike" = "milike",
    "NotLike" = "not_like",
    "NotIlike" = "not_ilike",
    "StartsWith" = "sw",
    "EndsWith" = "ew",
    "NotStartsWith" = "not_sw",
    "NotEndsWith" = "not_ew",
    "Equal" = "eq",
    "NotEqual" = "not",
    "Between" = "btw",
    "NotBetween" = "not_btw",
    "GreaterThan" = "gt",
    "LessThan" = "lt",
    "GreaterThanOrEqual" = "gt_eq",
    "LessThanOrEqual" = "lt_eq",
    "In" = "in",
    "NotIn" = "not_in",
    "Empty" = "mt",
    "EmptyOrNull" = "mt_null",
    "Null" = "null",
    "NotNull" = "not_null",
}
export enum SettingKey {
    "UniqueFormulaClick" = "unique_formula_click",
    "UniqueFormulaLead" = "unique_formula_lead",
    "TenantLogo" = "tenant_logo",
    "TenantFavicon" = "tenant_favicon",
    "MinimumPayout" = "minimum_payout",
    "FrontendUrl" = "frontend_url",
    "FrontendProcessesUrl" = "frontend_processes_url",
    "Language" = "language",
    "Currency" = "currency",
    "Country" = "country",
    "AffiliateBilling" = "affiliate_billing",
    "WebhookCustomParameters" = "webhook_custom_parameters",
    "WebhookEid" = "webhook_eid",
    "WebhookAdvertiserId" = "webhook_advertiser_id",
    "WebhookAdvertiserCustomId" = "webhook_advertiser_custom_id",
}
export enum SmsReportEventType {
    "Request" = "request",
    "RequestFail" = "request-fail",
    "RequestSuccess" = "request-success",
    "RequestTime" = "request-time",
    "CodeApproved" = "code-approved",
    "WrongCode" = "wrong-code",
    "CodeFilled" = "code-filled",
    "NumberChange" = "number-change",
    "NewCode" = "new-code",
    "CodeDidNotArrive" = "code-did-not-arrive",
}
export enum StepKeys {
    "Id" = "id",
    "Title" = "title",
    "Repeat" = "repeat",
    "Settings" = "settings",
    "Type" = "type",
    "Stop" = "stop",
}
export enum SubscriptionPeriod {
    "Monthly" = "monthly",
    "Yearly" = "yearly",
}
export enum SystemKeys {
    "RunId" = "run_id",
    "Title" = "title",
    "OneRun" = "one_run",
    "Repeat" = "repeat",
    "Sync" = "sync",
    "Errors" = "errors",
    "Data" = "data",
    "Test" = "test",
    "Wait" = "wait",
    "Stop" = "stop",
    "SyncNotAsyncWait" = "not_async_wait",
    "Meta" = "meta",
    "BranchEnded" = "branch_ended",
}
export enum TenantCategory {
    "AutomotiveLogisticsTransport" = "automotive_logistics_transport",
    "TravelVacations" = "travel_vacations",
    "BabyProductsToys" = "baby_products_toys",
    "SupplementsPharmaceuticals" = "supplements_pharmaceuticals",
    "ItServicesSoftware" = "it_services_software",
    "CultureEntertainmentMedia" = "culture_entertainment_media",
    "FashionApparelJewelryWatches" = "fashion_apparel_jewelry_watches",
    "HobbiesMiscellaneous" = "hobbies_miscellaneous",
    "ConsultingCoachingPersonalDevelopment" = "consulting_coaching_personal_development",
    "AdultDatingRelationshipServices" = "adult_dating_relationship_services",
    "SportsFitness" = "sports_fitness",
    "EducationOnlineCourses" = "education_online_courses",
    "HomeAppliances" = "home_appliances",
    "LanguagesTranslationServices" = "languages_translation_services",
    "PetsAnimalCare" = "pets_animal_care",
    "FinanceInsurance" = "finance_insurance",
    "BeautyCosmetics" = "beauty_cosmetics",
    "MarketingBusinessSupportSaas" = "marketing_business_support_saas",
    "FurnitureHomeInterior" = "furniture_home_interior",
    "ElectronicsGamingMultimedia" = "electronics_gaming_multimedia",
    "FoodBeverages" = "food_beverages",
    "DiscountPortalsExperienceAgencies" = "discount_portals_experience_agencies",
    "MobilePhonesAccessories" = "mobile_phones_accessories",
    "HealthBioHackingWellbeing" = "health_bio_hacking_wellbeing",
    "RealEstateHousing" = "real_estate_housing",
    "CryptoFintech" = "crypto_fintech",
    "LegalComplianceServices" = "legal_compliance_services",
    "B2bProfessionalServices" = "b2b_professional_services",
    "StreamingSubscriptions" = "streaming_subscriptions",
}
export enum TenantSettingAffiliateBilling {
    "UninvoicedBalance" = "uninvoiced_balance",
    "InvoicedBalance" = "invoiced_balance",
    "ApprovedBalance" = "approved_balance",
    "PaidBalance" = "paid_balance",
}
export enum UserRequestStatus {
    "Pending" = "pending",
    "Accepted" = "accepted",
    "Rejected" = "rejected",
    "Left" = "left",
    "Blocked" = "blocked",
    "Kicked" = "kicked",
}
export enum UserRequestType {
    "Tenant" = "tenant",
    "TenantInvite" = "tenant-invite",
    "Offer" = "offer",
}
export enum UserSettingKeyEnum {
    "Language" = "language",
    "Nickname" = "nickname",
    "Country" = "country",
    "Currency" = "currency",
    "ShowInPartnerCatalog" = "show_in_partner_catalog",
}
export enum UserWebTypeEnum {
    "CashbackSite" = "cashback_site",
    "SocialMediaInfluencer" = "social_media_influencer",
    "ContentWebsiteBlog" = "content_website_blog",
    "ProductCatalog" = "product_catalog",
    "SpecialPromotionType" = "special_promotion_type",
    "EmailMarketing" = "email_marketing",
    "CouponVoucherSite" = "coupon_voucher_site",
    "PpcArbitrage" = "ppc_arbitrage",
    "ReviewWebsite" = "review_website",
    "ComparisonWebsite" = "comparison_website",
    "LeadGenerationNetwork" = "lead_generation_network",
    "PriceAggregator" = "price_aggregator",
    "InfluencerContentCreator" = "influencer_content_creator",
}
